import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

const bulletedListConfig = [
  {
    bulletText: (
      <>
        <Typography nextElement='typography'>
          Download SEC&nbsp;
          <Link
            id='investing-disclosure-client-relationship-link'
            variant='primaryDeemphasize'
            linkUrl='/client-relationship-summary/'>
            Client Relationship Summary
          </Link>
          &nbsp;information.
        </Typography>
        <Typography nextElement='typography'>
          Our NMIS Customer Relationship Summary &#40;CRS&#41; provides you summary information about brokerage services through NMIS, and our NMWMC Customer Relationship Summary &#40;CRS&#41; provides you summary information about advisory services through NMWMC.
        </Typography>
      </>
    ),
  },
  {
    bulletText: (
      <>
        <Typography nextElement='typography'>
          Download the&nbsp;
          <Link
            id='investing-disclosure-brokerage-services-guide-link'
            variant='primaryDeemphasize'
            linkUrl='/assets/pdf/brochures/guide-to-brokerage-services.pdf'
            isInternalPdf>
            Guide to Brokerage Services
          </Link>
        </Typography>
        <Typography nextElement='typography'>
          The Guide to Brokerage Services disclosure brochure contains important information about the scope and terms of NMIS&#39;s brokerage services, conflicts of interest in connection with our brokerage offerings, and costs and sales charges related to the accounts and products we make available. This disclosure to clients is required by SEC Regulation Best Interest and is designed to provide you material information so your decisions about using our brokerage services are fully informed when investing through us.
        </Typography>
      </>
    ),
  },
  {
    bulletText: (
      <Typography nextElement='typography'>
        Download an&#160;
        <Link
          id='investing-disclosure-brochures-link'
          variant='primaryDeemphasize'
          linkUrl='/disclosure-brochures/'>
          Investment Advisory Program Disclosure Brochure
        </Link>
      </Typography>
    ),
  },
  {
    bulletText: (
      <>
        <Typography nextElement='typography'>
          Download&nbsp;
          <Link
            id='investing-disclosure-rollovers-distributions-link'
            variant='primaryDeemphasize'
            linkUrl='/assets/pdf/brochures/ira-rollovers-distributions.pdf'
            isInternalPdf>
            IRA Rollover and Distribution Options Brochure
          </Link>
        </Typography>
        <Typography nextElement='typography'>
          This brochure explains the benefits of a rollover IRA for when you are changing jobs or finally reach your goal of retirement. It compares alternative options, for example staying in your current plan or taking a cash distribution and offers an easy to understand chart comparing your options. Guide a conversation with a prospect or client who is preparing for a job change or nearing retirement about IRA options.
        </Typography>
      </>
    ),
  },
  {
    bulletText: (
      <Typography nextElement='typography'>
        Download the&#160;
        <Link
          id='investing-disclosure-brokerage-fee-schedule-link'
          variant='primaryDeemphasize'
          linkUrl='/assets/pdf/brochures/nmis-account-fee-schedule.pdf'
          isInternalPdf>
          Fee Schedule for brokerage accounts
        </Link>
      </Typography>
    ),
  },
  {
    bulletText: (
      <>
        <Typography nextElement='typography'>
          Download&nbsp;
          <Link
            id='investing-disclosure-client-general-agreement-link'
            variant='primaryDeemphasize'
            linkUrl='/assets/pdf/brochures/client-general-agreement.pdf'
            isInternalPdf>
            Client General Account Agreement
          </Link>
        </Typography>
        <Typography nextElement='typography'>
          This agreement includes the terms and conditions applicable to your brokerage account.
        </Typography>
      </>
    ),
  },
  {
    bulletText: (
      <>
        <Typography nextElement='typography'>
          Download information about the Northwestern Mutual FDIC Insured Deposit Program:
        </Typography>
        <Typography nextElement='typography'>
          <Link
            id='investing-disclosure-fdic-insured-deposit-link'
            variant='primaryDeemphasize'
            linkUrl='/assets/pdf/investing-disclosure/fdic-cashsweep-disclosurestatement.pdf'
            isInternalPdf>
            Northwestern Mutual FDIC Insured Deposit Program
          </Link>
          &nbsp;disclosure statement,&nbsp;
          <Link
            id='investing-disclosure-rate-sheet-link'
            variant='primaryDeemphasize'
            linkUrl='https://totalbanksolutions.com/resources-idp-nwm-rate-sheet/'
            isOutgoingLink>
            rate sheet
          </Link>, and&nbsp;
          <Link
            id='investing-disclosure-fdic-deposit-program-link'
            variant='primaryDeemphasize'
            linkUrl='https://totalbanksolutions.com/resources-idp-nwm-bank-list/'
            isOutgoingLink>
            bank list
          </Link>. The Northwestern Mutual FDIC Insured Deposit Program is the primary product in our Cash Sweep Program and will earn a daily interest rate for your uninvested assets. It&#39;s insured by the Federal Deposit Insurance Corporation &#40;FDIC&#41; for up to &#36;4 million<sup>1,2</sup>
        </Typography>
      </>
    ),
  },
  {
    bulletText: (
      <>
        <Typography nextElement='typography'>
          Download the&nbsp;
          <Link
            id='investing-disclosure-fund-family-list-link'
            variant='primaryDeemphasize'
            linkUrl='/assets/pdf/investing-disclosure/fund-vest-family.pdf'
            isInternalPdf>
            FundVest&#174; Fund Family List
          </Link>
        </Typography>
        <Typography nextElement='typography'>
          The link above provides a list of fund families participating in Pershing&#39;s FundVest&#174; program. Brokerage accounts opened through us are held at Pershing, which is an unaffiliated company that acts as a clearing firm to execute mutual fund trades and custody certain assets for us. Pershing receives servicing fees from certain mutual fund families to participate in Pershing&#39;s mutual fund no&#45;transaction&#45;fee program called FundVest&#174;. As described in the Guide to Brokerage Services, Pershing does not charge us clearance and execution fees for transactions in funds that participate in the FundVest&#174; program. This is a NMIS firm level conflict of interest because we receive an economic benefit from a client&#39;s mutual fund transactions in Pershing&#39;s FundVest&#174; program versus transactions in non&#45;FundVest&#174; program mutual funds due to the clearance and execution fee waiver.
        </Typography>
      </>
    ),
  },
  {
    bulletText: (
      <>
        <Typography nextElement='typography'>
          Download the&nbsp;
          <Link
            id='investing-disclosure-nmis-funds-list-link'
            variant='primaryDeemphasize'
            linkUrl='/assets/pdf/investing-disclosure/nmis-non-service-fee-funds.pdf'
            isInternalPdf>
            NMIS Non&#45;Service Fee Funds List
          </Link>
        </Typography>
        <Typography nextElement='typography'>
          The link above provides a list of mutual funds that, if made available based on the NMWMC research process, are subject to transaction fees for both buys and sells in the Northwestern Mutual Signature Choice program. Refer to the Signature Choice Program Disclosure Brochure available on this website for additional details on Transaction Fee Funds and related conflicts of interest.
        </Typography>
        <Typography nextElement='typography'>
          In addition, for brokerage accounts, the funds listed are NMIS Non&#45;Service Fee Funds that do not provide Pershing administrative service fees for offsetting costs of shareholder servicing or other similar expenses. Refer to the Guide to Brokerage Services available on this website for additional information on administrative service fee payments NMIS receives through Pershing from Service Fee Funds and related conflicts of interest.
        </Typography>

      </>
    ),
  },
  {
    bulletText: (
      <Typography disableBottomPadding>
        Download the&nbsp;
        <Link
          id='investing-disclosure-margin-agreement-link'
          variant='primaryDeemphasize'
          linkUrl='/assets/pdf/investing-disclosure/margin-agreement.pdf'
          isInternalPdf>
          Margin Agreement Disclosure
        </Link>
      </Typography>
    ),
  },
];

export default () => (
  <SectionContainer
    id='investing-disclosure'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          nextElement='typography'>
          Important Investment Disclosure Information
        </Typography>
        <Typography nextElement='typography'>
          Below are links to important investment disclosures and information to help you make informed decisions related to investing through us:
        </Typography>
        <BulletedList bulletedListData={bulletedListConfig} />
      </Col>
    </Row>
  </SectionContainer>
);
